import React from "react";
import { Modal, Button } from "react-bootstrap";
import Lottie from "lottie-react";
import successAnimation from "../../assets/animations/Success.json";

const TaxPaymentSuccessModal = ({ show, onHide }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
            dialogClassName="tax-success-modal"
            className="tax_payment_success_popup"
        >
            <Modal.Body>
                <div className="tax-success-wrapper">
                    <div className="tax-success-icon">
                        <Lottie
                            animationData={successAnimation}
                            loop={true}
                            style={{ width: 100, height: 100 }}
                        />
                    </div>

                    <h4 className="tax-success-title">Tax Marked as Paid</h4>

                    <p className="tax-success-text">
                        The tax record has been successfully updated and marked as paid for internal tracking purposes.
                        No payment was processed through the system.
                    </p>


                    <Button className="tax-success-btn btn_primary" onClick={onHide}>
                        Close
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default TaxPaymentSuccessModal;
